import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/estoques-depositos";

export const Route = createFileRoute("/_authenticated/estoques-depositos")({
  head: () => ({
    meta: [
      { title: "Estoques e depósitos — Milky Moo Palmares" },
      {
        name: "description",
        content: "Cadastro dos estoques e depósitos da empresa, com nome e situação de cada um.",
      },
      { property: "og:title", content: "Estoques e depósitos — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro dos estoques e depósitos da empresa, com nome e situação de cada um.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
